export default __webpack_public_path__ + "images/ec746a54d905f572a8e37f883474b39b-federal_government.webp";